import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import warning from "../../assets/icons/warning.png";

class LoginModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      errors: {
        password: "",
        email: "",
      },
      apiError: '',
      rememberMe: false,
    };
  }

  componentDidUpdate(prevProps){
    if(prevProps.error !== this.props.error){
      this.setState({apiError: this.props.error})
    }
  }

  handleInputChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  handleLogIn = (error, signInUser) => {
    this.validate();
    if (error === "") {
      signInUser();
    }
  };

  validate = () => {
    let errors = {
      password: "Password is required",
      email: "Email is required",
    };

    if (this.state.email === "" && this.state.password === "") {
      this.setState({ errors: errors });
    } else if (this.state.email === "") {
      errors = {
        password: "",
        email: "Email is required",
      };
      this.setState({ errors: errors });
    } else if (this.state.password === "") {
      errors = {
        password: "Password is required",
        email: "",
      };
      this.setState({ errors: errors });
    }
  };

  handleFocus = (field) => {
    let errors = {
      password: "",
      email: "",
    };
    if (field === "email") {
      errors = {
        password: this.state.errors.password,
        email: "",
      };
      this.setState({ errors: errors });
    } else if (field === "password") {
      errors = {
        password: "",
        email: this.state.errors.email,
      };
      this.setState({ errors: errors });
    }
  };

  onClose = (onclose) => {
    if (!this.state.rememberMe) {
      const errors = {
        password: "",
        email: "",
      };
      this.setState({
        email: "",
        password: "",
        errors: errors,
        rememberMe: false,
      });
    }
    onclose();
  };

  render() {
    const {
      signInopenModal,
      onclose,
      getInputKeyAndValue,
      signInUser,
      openSignUpModal,
      openPasswordResetModal,
      error,
      loading,
    } = this.props;

    let warningEmail, warningPassword;

    if (this.state.errors.email !== "") {
      warningEmail = (
        <img
          src={warning}
          alt="warning"
          width="14px"
          height="14px"
          style={{ marginRight: "6px" }}
        />
      );
    }

    if (this.state.errors.password !== "") {
      warningPassword = (
        <img
          src={warning}
          alt="warning"
          width="14px"
          height="14px"
          style={{ marginRight: "6px" }}
        />
      );
    }

    return (
      <Modal
        size="lg"
        centered
        className="Login-modal"
        show={signInopenModal}
        onHide={() => this.onClose(onclose)}
      >
        <div
          className="text-center"
          style={{
            width: "100%",
            borderBottom: "0.3px solid lightgray",
            margin: "0px",
            paddingTop: "20px",
            paddingBottom: "20px",
          }}
        >
          <span
            style={{
              width: "100%",
              fontFamily: "CircularStdMedium, Arial, sans-serif",
              fontSize: "16px",
              fontWeight: "bold",
              color: "black",
              textAlign: "center",
              fontStretch: "normal",
              fontStyle: "normal",
              letterSpacing: "normal",
            }}
          >
            Log in
          </span>
        </div>
        <button
          onClick={() => this.onClose(onclose)}
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          style={{
            position: "absolute",
            zIndex: "9999",
            top: "15px",
            right: "50px",
            width: "30px",
            height: "32px",
            paddingBottom: "15px",
            border: "none",
            backgroundColor: "white",
          }}
        >
          <span
            aria-hidden="true"
            style={{
              fontWeight: "bold",
              fontStrech: "normal",
              fontSize: "20px",
              color: "black",
              lineHeight: "normal",
              backgroundColor: "white",
            }}
          >
            x
          </span>
        </button>

        <Modal.Body style={{ marginBottom: "-25px" }}>
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="form">
                  <div className="floating-label">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      placeholder="Email"
                      className={this.state.errors.email ? "errorInput" : null}
                      value={this.state.email}
                      onChange={(e) => {
                        this.handleInputChange(e);
                        getInputKeyAndValue(e);
                      }}
                      onFocus={() => this.handleFocus("email")}
                      onBlur={(e) => {}}
                    />
                    <label className={this.state.errors.email ? "label" : null}>
                      Email
                    </label>
                  </div>
                  <div className="error">
                    {warningEmail}
                    {this.state.errors.email}
                  </div>

                  <div className="floating-label">
                    <input
                      id="password"
                      name="password"
                      type="password"
                      placeholder="Password"
                      className={
                        this.state.errors.password ? "errorInput" : null
                      }
                      value={this.state.password}
                      onChange={(e) => {
                        this.handleInputChange(e);
                        getInputKeyAndValue(e);
                      }}
                      onFocus={() => this.handleFocus("password")}
                      onBlur={(e) => {}}
                    />
                    <label
                      className={this.state.errors.password ? "label" : null}
                    >
                      Password
                    </label>
                  </div>
                  <div className="error">
                    {warningPassword}
                    {this.state.errors.password}
                  </div>
                </div>

                <div className="checkBoxContainers">
                  <label className="container">
                    Remember me
                    <input
                      type="checkbox"
                      value={this.state.rememberMe}
                      onChange={() => {
                        this.setState({ rememberMe: !this.state.rememberMe });
                      }}
                      checked={this.state.rememberMe}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>

                <div className="error text-center">
                    {this.state.apiError}
                  </div>

                <button
                  type="button"
                  className="btn-lg-block login-btn mb-3"
                  onClick={() => this.handleLogIn(error, signInUser)}
                  style={{
                    height: "57px",
                    padding: "18px",
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "bold",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "1.25",
                    letterSpacing: "0.08px",
                    textAlign: "center",
                    color: "#ffffff",
                  }}
                >
                  {loading ? (
                    <span
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Spinner
                        animation="border"
                        style={{ width: "25px", height: "25px" }}
                      />
                    </span>
                  ) : (
                    "Log in"
                  )}
                </button>

                <p onClick={openPasswordResetModal}>
                  <button
                    type="button"
                    style={{
                      fontWeight: "600",
                      color: "#0f0f0f",
                      textDecoration: "underline",
                      textAlign: "left",
                      border: "none",
                      padding: "0px",
                      backgroundColor: "white",
                    }}
                  >
                    Forgotten your password?
                  </button>
                </p>

                <p
                  onClick={openSignUpModal}
                  style={{
                    width: "100%",
                    fontFamily: "OpenSans, Arial, sans-serif",
                    fontSize: "14px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    letterSpacing: "normal",
                    textAlign: "left",
                    color: "#535252",
                  }}
                >
                  Don't have an account?{" "}
                  <button
                    type="button"
                    style={{
                      fontWeight: "600",
                      color: "#0f0f0f",
                      textDecoration: "underline",
                      border: "none",
                      padding: "0px",
                      backgroundColor: "white",
                    }}
                  >
                    Sign Up
                  </button>
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default LoginModal;
